export enum LIST_NUMBER_TYPE_ENUM {
  NUMBER = 'NUMBER',
  LETTER = 'LETTER',
  ROMAN = 'ROMAN',
}
